export function staffOvertime(state = [], action) {
  switch (action.type) {
    case "STAFF_OVERTIME_FETCH_DATA_SUCCESS":
      return action.staffOvertime;
    default:
      return state;
  }
}
